module.exports = __webpack_public_path__ + "media/images/static/consult/img02-6bbaca541ba05096e9ebb8c5cb59da21.png";